<template>
    <div>
        <div class="td-card shadow" id="accountHeader" ref="headerElement">
            <div class="info-header">
                <div>
                    <h2 class="td-h4 heading ma-0" style="display: inline;">
                        <a :href="'/accounts/admin/' + accountSummary.ain">
                            <span class="td-text-primary">{{accountSummary.ain}}</span>&nbsp;
                            {{accountSummary.n}}
                            <span v-if="accountSummary.info.address">
                                - {{accountSummary.info.address.regionCode}}, {{accountSummary.info.address.city}}
                            </span>
                            <span class="comments" v-if="accountSummary.comments.length > 0">
                                <icon class="icon" type="solid" name="faMessage" aria-hidden="true"></icon>
                                <span class="comments-count">{{accountSummary.comments.length}}</span>
                            </span>
                        </a>
                    </h2>
                    <icon @click="showEditAccountHeader = !showEditAccountHeader" type="solid" name="faPen" class="td-text-primary edit-badge ml-4" style="display: inline;"></icon>

                    <div class="status td-text-subdued td-text-small">
                        <span><icon :class="[accountStatus == 'Active' ? 'td-text-success' : 'td-text-danger', 'icon']" type="solid" name="faCircle" aria-hidden="true"></icon>&nbsp; {{accountStatus}} - <span>{{ subscriptionType}}</span></span>
                        <span class="divider"> | </span>
                        <span>{{accountType}}</span>
                        <span class="divider"> | </span>
                        <span v-if="accountSummary.lastActivityDate" class="mr-2"> Last activity on {{dateDisplay(accountSummary.lastActivityDate)}}</span>
                        <span v-else class="mr-2">No user activity recorded</span>
                        <button class="td-link icon-left verify-btn no-underline" title="Verify Account" @click.prevent="showVerifyModal = true">
                            <icon class="icon" type="solid" name="faCheck" aria-hidden="true"></icon> Verify Account
                        </button>
                    </div>
                </div>
                <div class="header-actions">
                    <div class="switch-wrapper">
                        <select class="type-select" v-model="accountTypeForDisplay" @change="changeDisplay($event)" aria-label="Account Type">
                            <option :value="AccountType.Fleet">Fleet</option>
                            <option :value="AccountType.Vendor">Vendor</option>
                            <option :value="AccountType.CallCenter">Call Center</option>
                            <option :value="AccountType.Developer">Developer</option>
                        </select>
                    </div>
                    <button class="td-btn icon-only" @click="showSummary=true" title="Account Summary"><icon class="icon" type="solid" name="faInfoCircle" aria-hidden="true"></icon></button>
                    <a class="td-btn icon-only" :href="emailLink" title="Email Customer"><icon class="icon" type="solid" name="faEnvelope" aria-hidden="true"></icon></a>
                    <a class="td-btn icon-only tasks-link" :href="tasksLink" title="View account related tasks">
                        <icon class="icon" type="solid" name="faListCheck" aria-hidden="true"></icon>
                        <span v-if="taskCount > 0" class="td-circle-badge">{{taskCount}}</span>
                    </a>
                    <button class="td-btn primary icon-left" @click="toggleTaskCreator" title="Create Task"><icon class="icon" type="solid" name="faPlus" aria-hidden="true"></icon>New Task</button>
                </div>
            </div>
        </div>

        <transition name="modal">
            <modal v-if="showTaskCreator" @close="toggleTaskCreator">
                <create-task @complete="completeTaskCreator" @cancel="toggleTaskCreator" :account-id="accountSummary.ain.toString()"></create-task>
            </modal>
        </transition>

        <transition name="modal">
            <modal v-if="showSummary" @close="showSummary=false">
                <account-summary :account-summary="accountSummary"
                                 :selected-type-for-display="accountTypeForDisplay"
                                 class="account-summary dark-cards">
                </account-summary>
            </modal>
        </transition>
        <div v-if="showVerifyModal">
            <verify-account :account-id="accountSummary.id"></verify-account>
        </div>

        <transition name="modal">
            <div v-if="showEditAccountHeader">
                <edit-account-header :account-summary="accountSummary" @cancel="cancelEditAccountHeader" @update="reloadAccountHeader"></edit-account-header>
            </div>
        </transition>
    </div>
</template>
<script>
    import script from './AccountHeader';
    export default script;</script>

<style lang="less">
    @import "./AccountHeader.less";
</style>